import accountClient from '../../api/central/account'
import teamsClient from '../../api/central/teams'

// state
const state = {
    currentAccount: {},
    accounts: []
};

// getters
const getters = {

};

// actions
const actions = {
    async getCurrentAccount({ commit }) {
        await accountClient.show()
            .then(({ data }) => commit("setCurrentAccount", data.data))
            .catch((error) => { throw error.response.data.message })
    },
    async getAccountsByUser({ commit }) {
        await teamsClient.index()
            .then(({ data }) => commit("setAccountsByUser", data.data.teams))
            .catch((error) => { throw error.response.data.message })
    },
};

// mutations
const mutations = {
    setCurrentAccount(state, currentAccount) {
        state.currentAccount = currentAccount;
    },
    setAccountsByUser(state, accounts) {
        state.accounts = accounts;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
